( function () {
	'use strict';

	function ForgotPasswordCtrl ( Session, logger, ForgotPasswordService, $location ) {
		var self = this;

		self.emailFlag = false;

		function forgotPasswordHandler ( email ) {
			function forgotPasswordSuccessCallback ( response ) {
				if ( response.data.indexOf( '0' ) > -1 ) {
					logger.notifyError( 'Sorry, we don\'t have an account using that email address.' );
				} else {
					self.emailFlag = true;
				}
			}

			ForgotPasswordService.forgotPassword( email ).then( forgotPasswordSuccessCallback );
		}

		function redirectHandler () {
			$location.path( '/' );
		}

		function activate () {
			logger.info( 'Activated Forgot Password View' );

			self.forgotPassword = forgotPasswordHandler;
			self.redirect       = redirectHandler;
		}

		activate();
	}

	angular
		.module( 'app.forgot-password' )
		.controller( 'ForgotPasswordCtrl', ForgotPasswordCtrl );

	ForgotPasswordCtrl.$inject = [ 'Session', 'logger', 'ForgotPasswordService', '$location' ];
} )( );
